@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Deposit Policy
      </h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Give the deposit policy a descriptive name and then define how this policy works.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">Deposit Policy Name</label>
            <input [(ngModel)]="DepositPolicy.name" id="classname" type="text" [ngStyle]="{'border-color': (DepositPolicyNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
          </div>
          @if (!DepositPolicyNameValid) {
            <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Deposit Policy name.</div>
          }
          <div class="field mb-4 col-12">
            <label for="depositpolicytype" class="font-medium">Deposit Policy Type</label>
            <p-selectbutton id="depositpolicytype" [style]="{'width' : '600px'}" [options]="stateOptions" [(ngModel)]="DepositPolicy.type" ></p-selectbutton>
          </div>
          @if (DepositPolicy.type != 'NoDeposit') {
            <div class="field mb-4 col-12">
              <label for="depositpolicytype" class="font-medium">Amount</label>
              @if (DepositPolicy.type == 'Fixed' || DepositPolicy.type == 'PerPerson' ) {
                <p-inputnumber [(ngModel)]="DepositPolicy.amount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputnumber>
              }
              @if (DepositPolicy.type == 'Percentage') {
                <p-inputnumber [(ngModel)]="DepositPolicy.amount" [maxFractionDigits]="2" suffix="%" locale="en-GB" [min]="0" [max]="9999"> </p-inputnumber>
              }
            </div>
          }
          <!-- A different deposit closer to the Start Date. Offered on Percentage and Fixed
          policies, the wording and the input following whichever it is. -->
          @if (DepositPolicy.type == 'Percentage' || DepositPolicy.type == 'Fixed') {
            <div>
              <div class="field mb-4 col-12">
                <label for="depositpolicytype" class="font-medium">Use a different {{DepositPolicy.type == 'Fixed' ? 'Amount' : 'Percentage'}} if booking is closer to Start Date?</label>
                <p-selectbutton [style]="{'width': '300px'}" [options]="stateOptions2" [(ngModel)]="alternativepercentage" ></p-selectbutton>
              </div>
              @if (alternativepercentage) {
                <div>
                  <div class="field mb-4 col-12">
                    <label for="depositpolicytype" class="font-medium">How many days before the Start Date do you want use this {{DepositPolicy.type == 'Fixed' ? 'amount' : 'percentage'}}</label>
                    <p-inputnumber id="concurrentUses" [style]="{'width': '300px'}" [ngModel]="DepositPolicy.alternativeamountthreshold== null ? 0: DepositPolicy.alternativeamountthreshold" (ngModelChange)="DepositPolicy.alternativeamountthreshold = $event" [showButtons]="true" max="999" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                  </div>
                  <div class="field mb-4 col-12">
                    <label for="depositpolicytype" class="font-medium">{{DepositPolicy.type == 'Fixed' ? 'Amount' : 'Percentage'}} to use if closer to Start Date</label>
                    @if (DepositPolicy.type == 'Fixed') {
                      <p-inputnumber [(ngModel)]="DepositPolicy.alternativeamount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputnumber>
                    }
                    @if (DepositPolicy.type == 'Percentage') {
                      <p-inputnumber [(ngModel)]="DepositPolicy.alternativeamount" [maxFractionDigits]="2" suffix="%" locale="en-GB" [min]="0" [max]="9999"> </p-inputnumber>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <div class="field mb-4 col-12">
            <label for="includeextras" class="font-medium">Deposit must cover the full cost of any extras?</label>
            <p-selectbutton id="includeextras" [style]="{'width': '300px'}" [options]="stateOptions2" [(ngModel)]="DepositPolicy.includeextras"></p-selectbutton>
            <small class="block mt-1" style="color:#6c757d;">When set to Yes, the deposit taken is never less than the total cost of the extras on the booking.</small>
          </div>
          <div class="field mb-4 col-12">
            <label for="allowfullpayment" class="font-medium">Allow customer to pay in full?</label>
            <p-selectbutton id="allowfullpayment" [style]="{'width': '300px'}" [options]="stateOptions2" [(ngModel)]="DepositPolicy.allowfullpayment"></p-selectbutton>
            <small class="block mt-1" style="color:#6c757d;">When set to Yes, the customer is offered the choice of paying the whole amount instead of just the deposit.</small>
          </div>
          <div class="col-12">
            <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
            Save Changes</button>
            &nbsp;
            <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
              <span class="pi pi-times" style="margin-right:8px;"></span>
            Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}